module.exports = __webpack_public_path__ + "static/media/vektskal.9fc6974e.m4a";